import { fromJS } from 'immutable';
import get from 'lodash/get';
import pick from 'lodash/pick';

import {
  ANSWERS__POST,
  RESULT__FETCH,
  RESULT__INIT,
  RESULT__FINALISE,
  SURVEY_CLIENT__PATCH,
  SURVEY_CLIENT__TOGGLE_PROGRESS,
  SURVEYS__FETCH_ACTIVE,
  SURVEYS__GET,
} from '../constants';

import { patch, restoreState, saveState, initGTM } from '../../util';
import { getBeginType, getErrorType } from '../../../researcher/redux/selectors';
import { isQualificationRejection } from '../result/util.result';

const defaultState = fromJS({
  answersSubmitError: null,
  initInFlight: false,
  isInitialized: false,
  isPreview: true,
  lyticsAccountId: null,
  selectedPageIndex: 0,
  showPreviousButton: null,
  showProgress: false,
  token: null,
  version: 'latest',
});

const getStorageKey = () => window.location.pathname;

function patchAndSave(state, data) {
  const nextState = patch(state, data);

  const storageKey = getStorageKey();

  return nextState.get('isPreview') ? nextState : saveState(nextState, storageKey);
}

/* eslint-disable camelcase */

export default function surveyClientReducer(state = defaultState, action) {
  switch (action.type) {
    case getBeginType(ANSWERS__POST):
      return state.set('answersSubmitError', null);
    case ANSWERS__POST: {
      const nextState = state.set('answersSubmitError', null);
      return patchAndSave(nextState, pick(action.data.result, ['version', 'survey_id']));
    }
    case getErrorType(ANSWERS__POST): {
      const message = get(action, ['error', 'response', 'data', 'errors', 0, 'message'], null);
      return state.set('answersSubmitError', fromJS({ message }));
    }
    case SURVEY_CLIENT__TOGGLE_PROGRESS:
      return state.set('showProgress', !state.get('showProgress'));
    case getBeginType(RESULT__INIT):
      return state.set('initInFlight', true);
    case RESULT__INIT: {
      if (state.get('token')) {
        return state.merge({ isInitialized: true, initInFlight: false });
      }
      const { token } = action.data;
      const { survey_id, version } = action.data.result;
      const nextState = patchAndSave(state.set('initInFlight', false), {
        token,
        survey_id,
        version,
      });
      return nextState.merge({ isInitialized: true });
    }
    case getErrorType(RESULT__INIT): {
      const nextState = state.set('initInFlight', false);
      if (isQualificationRejection(action.error)) {
        return nextState.merge({ isInitialized: true });
      }
      return nextState.merge({ isInitialized: false });
    }
    case getErrorType(RESULT__FETCH):
      return state.merge({ isInitialized: false });
    case SURVEY_CLIENT__PATCH:
      return patch(state, action.data);
    case SURVEYS__FETCH_ACTIVE: {
      const {
        id,
        latest_version,
        lytics_account_id: lyticsAccountId,
        gtm_id: gtmId,
      } = action.data.survey;
      initGTM(gtmId);
      const storageKey = getStorageKey();
      const restoredState = restoreState(storageKey, defaultState, 24);

      const nextState =
        restoredState.get('version') === latest_version
          ? restoredState
          : defaultState.merge({
              survey_id: id,
              token: action.data.token || null,
              version: latest_version,
            });

      return nextState.merge({
        answersSubmitError: null,
        initInFlight: false,
        isInitialized: true,
        isPreview: false,
        lyticsAccountId,
        pagesVersion: action.data.version,
        showPreviousButton: action.data.survey.previous_button,
      });
    }
    case SURVEYS__GET:
      return patch(state, { showPreviousButton: action.data.previous_button });
    case RESULT__FINALISE:
      return patch(state, action.data);
    default:
      return state;
  }
}

/**
 * @see docs/worklog/maintenance/20093-investigate-facebook-auth-errors/rfc-frontend.md
 */
